// extracted by mini-css-extract-plugin
export default {"directorAndStarring":"LXnxs","line":"Em3_m","label":"Cg14t","castText":"KJR4e"};